<template>
  <div
    class="tw-absolute tw-right-2 tw-top-32 tw-z-[160] tw-h-auto tw-items-center tw-justify-center lg:tw-right-8 lg:tw-top-44"
    id="theme3-circle-cta"
  >
    <div
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-px-10 tw-py-6 tw-text-center tw-text-white tw-shadow-lg hover:tw-border-opacity-0 lg:tw-h-[260px] lg:tw-w-[260px] lg:tw-px-12 lg:tw-py-8"
      :style="`background-color: var(--${vars.backgroundColor}); border-color: var(--${vars.borderColor})`"
    >
      <div class="tw-mb-2">
        <template v-for="(item, index) in titles" :key="`title-${index}`">
          <p
            class="tw-mb-[2px]"
            :class="{
              'font-plus-jakarta-bold tw-text-xl lg:tw-text-4xl': item.title_weight === 'bold',
              'font-plus-jakarta-semibold tw-text-base lg:tw-text-3xl': item.title_weight === 'semibold',
              'font-plus-jakarta': item.title_weight === 'regular',
            }"
          >
            {{ item.title }}
          </p>
        </template>
      </div>
      <nuxt-link
        :to="vars.buttonUrl"
        :external="true"
        :class="{
          'pxp-search-properties-btn': vars.buttonTypeText === 'primary',
          'pxp-primary-cta pxp-animate after:tw-border-inherit': vars.buttonTypeText === 'secondary',
        }"
        :style="`background-color: var(--${vars.buttonBackgroundColor}); color: var(--${vars.buttonTextColor}); ${
          vars.buttonTypeText === 'secondary' ? `border-top-color: var(--${vars.buttonTextColor});` : ''
        }`"
      >
        {{ vars.buttonText }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'CircleCTA',

  mixins: [ComponentMixin],

  computed: {
    titles() {
      return this.groupedVariables.titles;
    },
  },
});
</script>
<style scoped></style>
